<template>
  <b-modal
    :visible="show"
    body-class="p-0"
    :centered="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    hide-footer
    hide-header
  >
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title mt-0 heading-large">Create Price Quote</h1>
        <button
          type="button"
          data-dismiss="modal"
          class="modal-close"
          aria-label="Cancel"
          @click="cancelCreatePriceQuote()"
        >
          <i class="fas fa-lg fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-justify">
          Please select how long this quote should remain valid for. You can return to previously saved price quotes by
          selecting Price Quotes in the Order Capture page.
        </p>
        <div class="group-rounded-box m-1 p-4">
          <div class="row m-0 p-0">
            <div class="col-2" />
            <div class="col-3 justify-content-center align-self-center p-0">
              <label> Quote valid for </label>
            </div>
            <cleave
              class="col-5"
              placeholder="Enter value in minutes"
              :options="naturalNumber"
              v-model="expirationTimeInMinutes"
            ></cleave>
            <div class="col-2"></div>
            <div class="col-5 p-0" />
            <div class="col-5 p-0">
              <span v-if="expirationTimeStatus === eExpirationTimeStatus.invalid" class="error-message">
                Enter a value between {{this.minExpirationTime }} and {{ this.maxExpirationTime }} minutes
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-tertiary" id="cancelButton" @click="cancelCreatePriceQuote()" data-dismiss="modal">
          Cancel
        </button>
        <button
          class="btn btn-primary"
          :disabled="expirationTimeStatus !== eExpirationTimeStatus.valid"
          @click="confirmCreatePriceQuote()"
          data-dismiss="modal"
        >
          Confirm
        </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      expirationTimeInMinutes: "",
      minExpirationTime: 1,
      maxExpirationTime: 300,
      eExpirationTimeStatus: {
        empty: "EMPTY",
        valid: "VALID",
        invalid: "INVALID",
      },
    };
  },
  props: {
    show: {
      Type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("inputCheckers", ["naturalNumber"]),
    expirationTimeStatus: function () {
      if (this.expirationTimeInMinutes === "") {
        return this.eExpirationTimeStatus.empty;
      }
      if (
        Number(this.expirationTimeInMinutes) >= this.minExpirationTime &&
        Number(this.expirationTimeInMinutes) <= this.maxExpirationTime
      ) {
        return this.eExpirationTimeStatus.valid;
      }
      return this.eExpirationTimeStatus.invalid;
    },
  },
  methods: {
    cancelCreatePriceQuote: function () {
      this.$emit("cancel-create");
      this.expirationTimeInMinutes = "";
    },
    confirmCreatePriceQuote: function () {
      this.$emit("confirm-create", this.expirationTimeInMinutes);
      this.expirationTimeInMinutes = "";
    },
  },
};
</script>
